import type { ParametersUnit } from "@/lib/api";
import type { TimeSeriesParameterOption } from "@/features/shared/widgets/map/time-series/time-series-parameter.types";
import { resolveParameterUnit } from "@/features/shared/widgets/map/time-series/time-series-parameter-option.utils";
import {
  fmtMarkerDisplayText,
  isWindDirectionParameter,
} from "@/features/shared/widgets/observations-map/marker-display-state";

const SAMPLE_BY_UNIT_CODE: Record<string, number | string> = {
  degree: 270,
  degree_celsius: 18,
  foot: 1200,
  hectopascal: 1013,
  knot: 12,
  millimeter: 0.2,
  okta: 3,
  percent: 75,
};

function sampleValueForUnit(unit: ParametersUnit | undefined): number | string {
  const code = unit?.code;
  return code && SAMPLE_BY_UNIT_CODE[code] !== undefined ? SAMPLE_BY_UNIT_CODE[code] : 12;
}

/** Unit-aware sample value for CMS marker bubble previews. */
export function formatMarkerBubblePreviewText(
  param: TimeSeriesParameterOption,
  unitCode: string | undefined,
): string {
  const unit = resolveParameterUnit(param, unitCode);
  return fmtMarkerDisplayText(unit, sampleValueForUnit(unit), param.id);
}

export function isMarkerBubblePreviewWindDirection(
  param: TimeSeriesParameterOption,
  unitCode: string | undefined,
): boolean {
  return isWindDirectionParameter(param.id, resolveParameterUnit(param, unitCode));
}

export function markerBubblePreviewWindDirectionDegrees(
  param: TimeSeriesParameterOption,
  unitCode: string | undefined,
): number {
  const sample = sampleValueForUnit(resolveParameterUnit(param, unitCode));
  return typeof sample === "number" ? sample : Number(sample);
}
